export default __webpack_public_path__ + "static/media/mongal.1de5e450.png";